import { fetch } from '../request';

export const postCopyToPersonal = (body: { ids: number[] }) => {
  return fetch('/youyan/project/copy_to_personal/', {
    method: 'POST',
    body: {
      ids: body.ids,
    },
  });
};

export const postRemoveAndIntoRoom = (params: { into_room: boolean; project_ids: number[] }) => {
  return fetch('/youyan/project/remove_and_into_room/', {
    method: 'POST',
    body: params,
  });
};
